import { Logo } from '@/modus/Logo';

export const LoadingSplash = () => {
  return (
    <main className="flex size-full flex-col items-center justify-center">
      <div className="relative flex aspect-square w-full max-w-md flex-col items-center justify-center p-8">
        <Logo size={56} loading />
      </div>
    </main>
  );
};

LoadingSplash.displayName = 'LoadingSplash';
